export default __webpack_public_path__ + "static/media/chaeyoung3.7f79c7b3.jpg";